module.exports = __webpack_public_path__ + "static/pic3-e8565b4fc693e579ae1391677cc81d7d.png";